import { createStore } from 'vuex'
//全局函数
export default createStore({
    state: {
        langugaeZhL: false
    },
    mutations: {},
    actions: {},
    modules: {}
})